var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "daterangepicker-btn", class: _vm.dateRangeButtonClass },
    [
      _c("i", { staticClass: "fa fa-calendar" }),
      _vm._v(" "),
      _c("span", { ref: "rangeText" }),
      _vm._v(" "),
      _c("strong", { staticClass: "caret" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }